import ClinicsList from "../components/ClinicsList/ClinicsList";

function ProfilePage() {
  return (
    <div className="m-5">
      <ClinicsList />
    </div>
  );
}

export default ProfilePage;
